import { Brand } from "types/common";
import { md5 } from "js-md5";

export const calculateHash = (str: string) => md5(str);

export const getSEOMetadataDeliveryKey = (brand: Brand, urlPath: string) => {
  const deliveryKey = `seo_${brand}_${urlPath.replace("/", "").split("?")[0]}`;

  if (deliveryKey.length > 150) {
    const prefix = urlPath.match("^(/browse|/promo)");

    if (prefix !== null && prefix[0].length) {
      const postfix = urlPath.substring(prefix[0].length);
      const urlHash = calculateHash(postfix.replace("/", "").split("?")[0]);

      return `seo_${brand}_${prefix[0].replace("/", "")}/${urlHash}`;
    }
  }

  return deliveryKey;
};
